import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from "firebase/auth";

export function getFirebaseApp(config?: any) {
  const firebaseConfig = {
    apiKey: config?.apiKey || process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyDQPtxbKyIWVjb8GCWtQwIXn4aYC-a3uvI",
    authDomain: config?.authDomain || process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "shopstag-41ea8.firebaseapp.com",
    projectId: config?.projectId || process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "shopstag-41ea8",
    storageBucket: config?.storageBucket || process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "shopstag-41ea8.firebasestorage.app",
    messagingSenderId: config?.messagingSenderId || process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "36521225136",
    appId: config?.appId || process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:36521225136:web:19c51ad781a07ad6ec4475",
  };

  if (!getApps().length) {
    return initializeApp(firebaseConfig);
  }
  return getApp();
}

export function getFirebaseAuth(config?: any) {
  const app = getFirebaseApp(config);
  return getAuth(app);
}

export async function loginWithGoogle(config?: any) {
  const auth = getFirebaseAuth(config);
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  const result = await signInWithPopup(auth, provider);
  const user = result.user;
  const idToken = await user.getIdToken();
  return {
    email: user.email!,
    name: user.displayName || user.email?.split('@')[0],
    photoUrl: user.photoURL,
    idToken,
    provider: 'google'
  };
}

export async function loginWithFacebook(config?: any) {
  const auth = getFirebaseAuth(config);
  const provider = new FacebookAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;
  const idToken = await user.getIdToken();
  return {
    email: user.email!,
    name: user.displayName || user.email?.split('@')[0],
    photoUrl: user.photoURL,
    idToken,
    provider: 'facebook'
  };
}
